import { useState, useEffect } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import CheckIcon from '@mui/icons-material/Check';
import AddIcon from '@mui/icons-material/Add';
import api from '../api/api';
import ToastMessage from '../utils/mui/righttoptoast';
import { useDispatch } from 'react-redux';
import { showToast } from '../reduxtoolkit/toastslice';
import { getPracticeId } from '../config/practice';

const Addentrymodalview = ({ setAddEntryModal, fetchinventry, setLoading }) => {
  const inputClass = "border px-3 py-1.5 rounded text-sm w-full bg-[#F3F4F6]";
  const selectClass = "border px-3 py-1.5 rounded text-sm w-full bg-[#F3F4F6] min-h-[40px] max-h-40 overflow-y-auto";
  const practiseid = getPracticeId();

  const [formData, setFormData] = useState({
    item_name: '',
    ndc_number: '',
    item_type: '',
    vendor: '',
    total_quantity: '',
    quantity_per_unit: '',
    primary_lot_number: '',
    lot_unit: '',
    inventory_low_warning_level: '',
    expiry_date: '',
    price: '',
    associated_order: '',
    patient_dosage_amount: '',
    dosage_unit: '',
      associated_order: "",              // ID (number)
  associated_order_label: "",
  });

  const [openToast, setOpenToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastSeverity, setToastSeverity] = useState('success');

  const [lotUnitOptions, setLotUnitOptions] = useState([]);
  const [dosageUnitOptions, setDosageUnitOptions] = useState([]);
  const [vendorOptions, setVendorOptions] = useState([]);
  const [itemTypeOptions, setItemTypeOptions] = useState([]);
  const [associateOrderOptions, setAssociateOrderOptions] = useState([]);
  const [selectedOrder, setSelectedOrder] = useState(null);

  const [lotUnitLoaded, setLotUnitLoaded] = useState(false);
  const [dosageUnitLoaded, setDosageUnitLoaded] = useState(false);
  const [vendorLoaded, setVendorLoaded] = useState(false);
  const [itemTypeLoaded, setItemTypeLoaded] = useState(false);

  const [editContext, setEditContext] = useState({});
  const [newContextValue, setNewContextValue] = useState({});
const dispatch=useDispatch()
  const handleToastClose = () => setOpenToast(false);

  const handleInputChange = (e, field) => {
    const value = e.target.value;
    setFormData(prev => ({ ...prev, [field]: value }));
  };

const validateForm = () => {
const requiredFields = [
  "item_name",
  "ndc_number",
  "item_type",
  "vendor",
  "total_quantity",
  "quantity_per_unit",
  "primary_lot_number",
  "lot_unit",
  "inventory_low_warning_level",
  "expiry_date",
  "price",
  "associated_order",
  "patient_dosage_amount",
  "dosage_unit",
];


  for (let field of requiredFields) {
    if (
      formData[field] === undefined ||
      formData[field] === null ||
      String(formData[field]).trim() === ""
    ) {
      const label = field
        .replace(/_/g, " ")
        .replace(/\b\w/g, (c) => c.toUpperCase());

      setToastMessage(`Please fill out the "${label}" field.`);
      setToastSeverity("error");
      setOpenToast(true);

      return false;
    }
  }

  return true;
};


  const searchAssociate = async (query) => {
    try {
      const response = await api.post(`/v1/${practiseid}/lookup_master/context`, {
        context: query
      });
      if (response.status === 200) {
        const data = response?.data || [];
        setAssociateOrderOptions(data);
      } else {
        setFormData(prev => ({ ...prev, associated_order: '' }));

          setAssociateOrderOptions([]);
      }
    } catch (error) {
      console.log(error);
      setAssociateOrderOptions([]);
    }
  };

  // Optional debounce
  const debounce = (func, delay) => {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => func(...args), delay);
    };
  };
  const debouncedSearchAssociate = debounce(searchAssociate, 300);

  const saveInventory = async () => {
    if (!validateForm()) return;
    setLoading(true);
    try {
      
      await api.post(`/v1/${practiseid}/inventory`, {
        ...formData,
        item_type: Number(formData.item_type),
        total_quantity: Number(formData.total_quantity),
        quantity_per_unit: Number(formData.quantity_per_unit),
        inventory_low_warning_level: Number(formData.inventory_low_warning_level),
        price: Number(formData.price),
        patient_dosage_amount: Number(formData.patient_dosage_amount),
        associated_order: Number(formData.associated_order)
      });

      // setToastMessage('Inventory saved successfully!');
      // setToastSeverity('success');
      // setOpenToast(true);
    dispatch(
          showToast({
            message:'Inventory saved successfully!',
            severity: "success",
          }),
        );
      fetchinventry();
   setAddEntryModal(false)
    } catch (error) {
      console.error(error);
      setToastMessage('Failed to save inventory');
      setToastSeverity('error');
      setOpenToast(true);
    } finally {
      setLoading(false);
    }
  };

  const fetchdropdown = async (context) => {
    setLoading(true);
    try {
      const response = await api.get(`/v1/${practiseid}/inventory_lookup?context=${context}`);
      const data = response?.data || [];
      if (context === 'lot_unit') setLotUnitOptions(data);
      if (context === 'dosage_unit') setDosageUnitOptions(data);
      if (context === 'vendor') setVendorOptions(data);
      if (context === 'item_type') setItemTypeOptions(data);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleDropdownClick = async (context) => {
    if (context === 'lot_unit' && !lotUnitLoaded) {
      await fetchdropdown(context); setLotUnitLoaded(true);
    }
    if (context === 'dosage_unit' && !dosageUnitLoaded) {
      await fetchdropdown(context); setDosageUnitLoaded(true);
    }
    if (context === 'vendor' && !vendorLoaded) {
      await fetchdropdown(context); setVendorLoaded(true);
    }
    if (context === 'item_type' && !itemTypeLoaded) {
      await fetchdropdown(context); setItemTypeLoaded(true);
    }
  };

  const handleAddContext = (context) => {
    setEditContext((prev) => ({ ...prev, [context]: true }));
    setNewContextValue((prev) => ({ ...prev, [context]: '' }));
  };

  const handleContextSave = async (context) => {
    const name = newContextValue[context]?.trim();
    if (!name) {
      setToastMessage('Please enter a valid name');
      setToastSeverity('error');
      setOpenToast(true);
      return;
    }

    try {
      await api.post(`/v1/${practiseid}/inventory_lookup`, {
        context,
        content: [{ name, status: 'A' }]
      });

      setToastMessage(`Added new ${context} successfully`);
      setToastSeverity('success');
      setOpenToast(true);

      await fetchdropdown(context);
      setEditContext((prev) => ({ ...prev, [context]: false }));
    } catch (error) {
      console.error(error);
      setToastMessage('Failed to add item');
      setToastSeverity('error');
      setOpenToast(true);
    }
  };

const renderDropdownOrInput = (context, options) => (
  <div className="flex gap-2">
    {editContext[context] ? (
      <>
        <input
          className={inputClass}
          placeholder={`Enter ${context.replace('_', ' ')}`}
          value={newContextValue[context] || ''}
          onChange={(e) =>
            setNewContextValue((prev) => ({ ...prev, [context]: e.target.value }))
          }
        />
        <button
          className="px-2 py-1.5 border rounded text-green-600 hover:bg-green-100"
          onClick={() => handleContextSave(context)}
        >
          <CheckIcon fontSize="small" />
        </button>
      </>
    ) : (
      <>
        <select
          className={selectClass}
          value={formData[context]}
          onChange={(e) => {
            const selectedId = Number(e.target.value);
            setFormData((prev) => ({ ...prev, [context]: selectedId }));
          }}
          onClick={() => handleDropdownClick(context)}
        >
          <option value="">Select {context.replace('_', ' ')}</option>
          {options.map((item) => (
            <option key={item.id} value={item.id}>
              {item.name}
            </option>
          ))}
        </select>
        <button className="px-3 py-1.5 border rounded" onClick={() => handleAddContext(context)}>
          <AddIcon fontSize="small" />
        </button>
      </>
    )}
  </div>
);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
      <div className="relative w-full max-w-4xl rounded-[8.75px] bg-white border p-0">
        <button className="absolute top-3 right-3 text-gray-600 hover:text-black" onClick={() => setAddEntryModal(false)}><CloseIcon /></button>
        <div className="px-6 pt-6"><h2 className="text-sm font-bold text-start">Add New Inventory</h2></div>
        <div className="border-b border-gray-300 mt-2 mb-4"></div>

        <div className="px-6 pb-6 space-y-6 max-h-[80vh] overflow-y-auto">
          {/* Basic Info */}
          <div>
            <p className="text-sm font-semibold mb-2 text-start">Basic Information</p>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="text-start">
                <label className="block text-xs font-medium mb-1">Item Name *</label>
                <input className={inputClass} value={formData.item_name} onChange={(e) => handleInputChange(e, 'item_name')} />
              </div>
              <div className="text-start">
                <label className="block text-xs font-medium mb-1">NDC Number</label>
                <input className={inputClass} value={formData.ndc_number} onChange={(e) => handleInputChange(e, 'ndc_number')} />
              </div>
              <div className="text-start">
                <label className="block text-xs font-medium mb-1">Item Type *</label>
                {renderDropdownOrInput('item_type', itemTypeOptions)}
              </div>
              <div className="text-start">
                <label className="block text-xs font-medium mb-1">Vendor/Supplier *</label>
                {renderDropdownOrInput('vendor', vendorOptions)}
              </div>
            </div>
          </div>

          {/* Quantity Info */}
          <div>
            <p className="text-sm font-semibold mb-2 text-start">Quantity Information</p>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              <div className="text-start">
                <label className="block text-xs font-medium mb-1">Total Quantity *</label>
                <input className={inputClass} value={formData.total_quantity} onChange={(e) => {
    const value = e.target.value;
    if (/^\d*$/.test(value)) {
      handleInputChange(e, 'total_quantity');
    }
  }} />
              </div>
              <div className="text-start">
                <label className="block text-xs font-medium mb-1">Quantity per Lot *</label>
                <input className={inputClass} value={formData.quantity_per_unit}   onChange={(e) => {
    const value = e.target.value;
    if (/^\d*$/.test(value)) {
      handleInputChange(e, 'quantity_per_unit');
    }
  }} />
              </div>
             <div className="text-start">
  <label className="block text-xs font-medium mb-1">
    Lot Number
  </label>
  <input
    className={inputClass}
    value={formData.primary_lot_number}
    onChange={(e) => {
      const value = e.target.value;
      if (/^\d*$/.test(value)) {
        handleInputChange(
          { target: { value } },
          "primary_lot_number"
        );
      }
    }}
    inputMode="numeric"
    placeholder="Enter lot number"
  />
</div>

              <div className="text-start">
                <label className="block text-xs font-medium mb-1">Lot Unit *</label>
                {renderDropdownOrInput('lot_unit', lotUnitOptions)}
              </div>
              <div className="text-start">
                <label className="block text-xs font-medium mb-1">Low Warning Level *</label>
                <input className={inputClass} value={formData.inventory_low_warning_level}   onChange={(e) => {
    const value = e.target.value;
    if (/^\d*$/.test(value)) {
      handleInputChange(e, 'inventory_low_warning_level');
    }
  }} />
              </div>
              <div className="text-start">
                <label className="block text-xs font-medium mb-1">Expiry Date *</label>
                <input type="date" className={inputClass} value={formData.expiry_date} onChange={(e) => handleInputChange(e, 'expiry_date')} />
              </div>
            </div>
          </div>

          {/* Pricing Info */}
          <div>
            <p className="text-sm font-semibold mb-2 text-start">Pricing Information</p>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="text-start">
                <label className="block text-xs font-medium mb-1">Purchase Price</label>
                <input type="number" className={inputClass} value={formData.price} onChange={(e) => handleInputChange(e, 'price')} />
              </div>
              {/* <div className="text-start relative">
                <label className="block text-xs font-medium mb-1">Associated Order</label>
                <input
                  className={inputClass}
                  value={formData.associated_order}
                  onChange={(e) => {
                    const value = e.target.value;
                    setFormData(prev => ({ ...prev, associated_order: value }));
                    setSelectedOrder(null);
                    if (value.length >= 0) {
                      searchAssociate(value);
                       debouncedSearchAssociate(value); // optional
                    } else {
                      setAssociateOrderOptions([]);
                    }
                  }}
                  onBlur={() => {
                    setTimeout(() => {
                      if (!selectedOrder) {
                        setFormData(prev => ({ ...prev, associated_order: '' }));
                      }
                      setAssociateOrderOptions([]);
                    }, 200);
                  }}
                />
                {associateOrderOptions.length > 0 && (
                  <ul className="absolute z-10 w-full bg-white border rounded shadow max-h-40 overflow-y-auto mt-1 text-sm">
                    {associateOrderOptions.map((item) => (
                      <li
                        key={item.id}
                        className="px-3 py-1 cursor-pointer hover:bg-gray-100"
                        onMouseDown={() => {
                          setFormData(prev => ({ ...prev, associated_order: item.id }));
                          setSelectedOrder(item);
                          setAssociateOrderOptions([]);
                        }}
                      >
                        {item.content}
                      </li>
                    ))}
                  </ul>
                )}
              </div> */}
              <div className="text-start relative">
  <label className="block text-xs font-medium mb-1">
    Associated Order *
  </label>

  <input
    className={inputClass}
    value={formData.associated_order_label}
    placeholder="Search and select order"
    onChange={(e) => {
      const value = e.target.value;

      // reset selected ID while typing
      setFormData(prev => ({
        ...prev,
        associated_order_label: value,
        associated_order: ""
      }));

      if (value.trim().length > 0) {
        debouncedSearchAssociate(value);
      } else {
        setAssociateOrderOptions([]);
      }
    }}
    onBlur={() => {
      // If user didn't select anything, clear input
      setTimeout(() => {
        if (!formData.associated_order) {
          setFormData(prev => ({
            ...prev,
            associated_order_label: "",
          }));
        }
        setAssociateOrderOptions([]);
      }, 200);
    }}
  />

  {associateOrderOptions.length > 0 && (
    <ul className="absolute z-10 w-full bg-white border rounded shadow max-h-40 overflow-y-auto mt-1 text-sm">
      {associateOrderOptions.map((item) => (
        <li
          key={item.id}
          className="px-3 py-1 cursor-pointer hover:bg-gray-100"
          onMouseDown={() => {
            setFormData(prev => ({
              ...prev,
              associated_order: item.id,           // ID for payload
              associated_order_label: item.content // label for UI
            }));
            setAssociateOrderOptions([]);
          }}
        >
          {item.content}
        </li>
      ))}
    </ul>
  )}
</div>

            </div>
          </div>

          {/* Usage Info */}
          <div>
            <p className="text-sm font-semibold mb-2 text-start">Usage Information</p>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="text-start">
                <label className="block text-xs font-medium mb-1">Patient Dosage Amount</label>
                <input className={inputClass} value={formData.patient_dosage_amount}  onChange={(e) => {
    const value = e.target.value;
    if (/^\d*$/.test(value)) {
      handleInputChange(e, 'patient_dosage_amount');
    }
  }} />
              </div>
              <div className="text-start">
                <label className="block text-xs font-medium mb-1">Dosage Unit</label>
                {renderDropdownOrInput('dosage_unit', dosageUnitOptions)}
              </div>
            </div>
          </div>
        </div>

        <div className="flex justify-end gap-2 px-6 pb-6">
          <button onClick={() => setAddEntryModal(false)} className="border px-4 py-1 rounded text-sm text-gray-700 hover:bg-gray-100">Cancel</button>
          <button onClick={saveInventory} className="bg-black text-white px-4 py-1 rounded text-sm">Save Inventory</button>
        </div>
      </div>

      <ToastMessage
        message={toastMessage}
        severity={toastSeverity}
        open={openToast}
        handleClose={handleToastClose}
      />
    </div>
  );
};

export default Addentrymodalview;
